import WidgetToggler from "../abstract/AbstractWidgetToggler.js";
import WidgetSimpleSearch from "./WidgetSimpleSearch.component.js";

/**
 * enables header widgets and custom select
 * */
export default class SiteHeader {
  /**
   * @param {HTMLElement} siteHeader
   * @param {boolean} hasSimpleSearch - if true enables simpleSearch widget
   * @param {JSON} simpleSearchData - options to render in virtualSelect
   * @param {object} userActions - widgetToggler: { btn, target }
   * @param {object} simpleSearch - widgetToggler: { btn, target }
   * @param {HTMLElement} vSelect
   * */
  constructor({ siteHeader, hasSimpleSearch = true, simpleSearchData, userActions, simpleSearch }) {
    this.siteHeader = siteHeader;
    this.hasSimpleSearch = hasSimpleSearch;
    this.simpleSearchData = simpleSearchData;
    this.userActions = userActions;
    this.simpleSearch = simpleSearch;

    // widgets to be enabled
    this.userActionsWidget, this.simpleSearchWidget, this.currentWidgetOpen;
  }

  init() {
    this.initCheckDeepSearch();

    this.initUserActions();
    this.hasSimpleSearch && this.initSimpleSearch(); // Ma che cazzo è sto && :-) usi troppo react ^_^

    this.closeCurrentWidgetOpen();
  }

  /**
   * inits user-actions widget
   * */
  initUserActions() {
    this.userActionsWidget = new WidgetToggler({
      ...this.userActions,
      callback: this.handleHeaderWidgetsEvents.bind(this),
    });
    this.userActionsWidget.init();
  }

  /**
   * inits simple-search widget
   * */
  initSimpleSearch() {
    this.simpleSearchWidget = new WidgetSimpleSearch({
      ...this.simpleSearch,
      callback: this.handleHeaderWidgetsEvents.bind(this),
    });
    this.simpleSearchWidget.init();
  }

  handleHeaderWidgetsEvents(e) {
    switch (e.type) {
      case "widgetopen":
        this.currentWidgetOpen?.close();
        this.currentWidgetOpen = e.widget;
        if (this.currentWidgetOpen === this.simpleSearchWidget) {
          this.simpleSearchWidget.target?.querySelector(".vscomp-search-input")?.focus();
        }
        break;

      case "widgetclose":
        this.currentWidgetOpen = null;
        break;
    }
  }

  get fullTextData() {
    const data = {
      text: this.simpleSearchWidget.text,
      collection: this.simpleSearchWidget.collection,
      field: this.simpleSearchWidget.field,
    };
    console.log(data);

    return data;
  }

  closeCurrentWidgetOpen() {
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.currentWidgetOpen?.close();
      }
    });

    document.body.addEventListener("click", (e) => {
      this.currentWidgetOpen?.close();
    });
  }

  initCheckDeepSearch() {
    // controlla il localstorage per vedere se è attiva la ricerca avanzata
    let deepSearch = localStorage.getItem("deepSearchPreference");
    let active = false;
    if (deepSearch === null) {
      localStorage.setItem("deepSearchPreference", JSON.stringify({ active: false }));
    } else {
      active = JSON.parse(deepSearch).active;
    }

    if (active) {
      // setta il checkbox
      jQuery(".js-deepSearch").prop("checked", true);
    }

    jQuery(".js-deepSearch").on("change", (e) => {
      let active = e.target.checked;
      localStorage.setItem("deepSearchPreference", JSON.stringify({ active }));
      this.simpleSearchWidget.toggleVSField();
    });
  }
}
